export default __webpack_public_path__ + "static/media/IMG_3723EDIT-mini.e00a11bf.jpg";